import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ShoppingCartComponent } from './components/shopping-cart/shopping-cart.component';
import { EnvironmentsComponent } from './components/environments/environments.component';
import { ReviewEnvironmentsComponent } from './components/review-environments/review-environments.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TimeagoModule } from 'ngx-timeago';
import { CommonLayoutModule } from '../../../common-layout/common-layout.module';
import { PopupComponent } from './components/popup/popup.component';
import { EnvironmentFormComponent } from './components/environment-form/environment-form.component';

@NgModule({
  declarations: [
    ShoppingCartComponent,
    EnvironmentsComponent,
    ReviewEnvironmentsComponent,
    PopupComponent,
    EnvironmentFormComponent
  ], 
  imports: [
    CommonModule,
    CommonLayoutModule,
    FontAwesomeModule,
    RouterModule,
    NgbToastModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    TimeagoModule,
    FormsModule,
  ],
  exports: [
    ShoppingCartComponent,
    EnvironmentsComponent,
    ReviewEnvironmentsComponent,
  ],
  providers: []
})
export class ShoppingCartModule { }
